import { WorldId } from "../constants";
import { AnimationMixer, AnimationClip, LoopOnce } from 'three';
import { CoverMaterial } from "../customMaterials/CoverMaterial";

export class BookManager {
    constructor({ model, assets }) {

        this.covers = [];
        this.actions = [];
        this.bookArmatures = [];
        this._openIndex = undefined;

        const { scene, animations } = model;

        // Create animation mixer
        this.mixer = new AnimationMixer(scene);

        // Just use names here so it's easier to follow: @see constants.js
        const { LITTLE_RED, OGRE, HIDDEN_WOLF } = WorldId;

        [LITTLE_RED, OGRE, HIDDEN_WOLF].forEach((portalIndex, index) => {
            const id = index + 1; // books are indeexed 1, 2, 3
            const coverObj = scene.getObjectByName(`cover${id}`);
            const material = new CoverMaterial({
                hatchingMap: assets.textures.hatchB,
                skinning: true,
                parameters: {
                    fog: false,
                    hatchingScale: 30,
                    mixDiffuse: 0.7,
                    blackLevel: 0,
                    whiteLevel: 1,
                    gamma: 1,
                },
            });

            // Don't understand this but...
            const mapBook = coverObj.material.map;
            coverObj.material = material;
            coverObj.material.map = mapBook;

            this.covers.push(coverObj);

            // Book armature (what is armature?)
            const bookArmature = scene.getObjectByName(`ArmatureBook${id}`);
            bookArmature.traverse((obj) => obj.frustumCulled = false);
            bookArmature.portal = scene.getObjectByName(`portal${portalIndex}`);
            this.bookArmatures.push(bookArmature);

            // animations
            const clip = AnimationClip.findByName(animations, `Book${id}Open`);
            this.actions.push(this.mixer.clipAction(clip));
        });
    }

    switchBook(index) {
        for (let i = 0; i < this.actions.length; i++) {
            this[`${i === index - 1 ? 'open' : 'close'}Book`](i);
        }
    }

    onUpdateStepComplete(step) {
        const bookSwitchMap = {
            1: 1,
            5: 3,
            6: 2,
        }

        const bk = bookSwitchMap[step];
        this.switchBook(bk ? bk : 0);
    }

    openBook(index) {
        // allow rendering
        const { world } = this.bookArmatures[index].portal;

        if (world) {
            world.allowRender = true;
        }

        // const action = this["action" + index];
        const action = this.actions[index];

        if (action.time === action.getClip().duration) {
            return;
        }

        action.reset()
        action.timeScale = 1.5;
        action.setLoop(LoopOnce)
        action.clampWhenFinished = true
        action.play();
    }

    closeBook(index) {
        // prevent rendering
        const { world } = this.bookArmatures[index].portal;

        if (world) {
            world.allowRender = false;
        }

        const action = this.actions[index];

        if (!action) {
            return;
        }

        if (action.time === 0) {
            return;
        }

        action.paused = false;
        action.timeScale = -1.5;
        action.setLoop(LoopOnce);
        action.play();
    }

    update({ time, deltaTime }) {
        this.mixer.update(deltaTime);
        this.covers.forEach(c => c.material.time = time);
    }
}